import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_122: FaireProductEntity = {
  token: "legacy_prod_abbott-122",
  type: "product",
  name: "Beehive Honey Pot W Lid",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/98a75ddb2580b081c60a4cd9aeb9c84bf053387a0f26412c7c6b3b8376500dcd.jpeg",
  priceDollars: 22,
  subcategory: "Serveware",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
